// The partner may change the `ref` format, so we don't check its exact format.
// We only block characters that could be used to inject HTML or script.
export function sanitizeLoginRef(ref: string | null): string | null {
  const trimmedRef = ref?.trim() ?? '';

  const isPrintableAscii = /^[\x21-\x7E]{1,256}$/.test(trimmedRef);
  const hasUnsafeChar = /[<>"'`]/.test(trimmedRef);

  return isPrintableAscii && !hasUnsafeChar ? trimmedRef : null;
}

function isLoginRefParam(name: string): boolean {
  return name.toLowerCase() === 'ref';
}

export function getLoginRefParamValue(
  urlParams: URLSearchParams,
): string | null {
  let ref: string | null = null;

  urlParams.forEach((value, name) => {
    if (ref === null && isLoginRefParam(name)) {
      ref = value;
    }
  });

  return sanitizeLoginRef(ref);
}

export function deleteLoginRefParams(urlParams: URLSearchParams): void {
  const refParamNames: string[] = [];

  urlParams.forEach((_value, name) => {
    if (isLoginRefParam(name)) {
      refParamNames.push(name);
    }
  });

  refParamNames.forEach((name) => urlParams.delete(name));
}
